export default {
  orderDetail(state) {
    return state.orderDetail
  },
  orderCancelInfo(state) {
    return state.bs_myp_05_040
  }
}